import home from './home.vue';
import toast from './component/toast.vue';
import actionsheet from './component/action-sheet.vue';
import invokeapi from './InvokeApi.vue';

let views = {
    home,
    toast,
    actionsheet,
    invokeapi
};

export default views;